import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const ConfigDocsHome = lazy(() => import('../components/ConfigDocsHome'))
const ModuleOverviewPage = lazy(() => import('../components/ModuleOverviewPage'))
const EntryPage = lazy(() => import('../components/EntryPage'))

export const ConfigDocsRoute: RouteObject = {
    path: 'config-docs',
    children: [
        { index: true, element: <ConfigDocsHome /> },
        { path: ':module', element: <ModuleOverviewPage /> },
        { path: ':module/:entryId', element: <EntryPage /> },
    ],
}

export default ConfigDocsRoute
